import { Box, Grid2 as Grid, Typography } from "@mui/material";
import { formatNumberWithSuffix } from "../../../../utils/functions";

/** Icons */
import Facebook from "../../../Assets/Img/facebook.png";
import Instagram from "../../../Assets/Img/instagram.png";
import Reddit from "../../../Assets/Img/reddit.svg";
import SnapChat from "../../../Assets/Img/SnapChat.jpg";
import Youtube from "../../../Assets/Img/youtube.png";

const getInstagramStats = (stats) => {
  return [
    {
      label: "Followers",
      value: stats?.followers ? formatNumberWithSuffix(stats?.followers) : 0,
    },
    {
      label: "Reach",
      value: stats?.reach ? formatNumberWithSuffix(stats?.reach) : "N/A",
    },
    {
      label: "Engagement",
      value: stats?.engagement
        ? formatNumberWithSuffix(stats?.engagement) + "%"
        : "N/A",
    },
    {
      label: "Avg. Likes",
      value: stats?.avg_likes ? formatNumberWithSuffix(stats?.avg_likes) : 0,
    },
    {
      label: "Avg. Comments",
      value: stats?.avg_comments
        ? formatNumberWithSuffix(stats?.avg_comments)
        : 0,
    },
    {
      label: "Avg. Shares",
      value: stats?.avg_shares ? formatNumberWithSuffix(stats?.avg_shares) : 0,
    },
  ];
};

const getYouTubeStats = (stats) => {
  return [
    {
      label: "Subscribers",
      value: stats?.subscribers
        ? formatNumberWithSuffix(stats?.subscribers)
        : 0,
    },
    {
      label: "Reach",
      value: stats?.reach ? formatNumberWithSuffix(stats?.reach) : "N/A",
    },
    {
      label: "Engagement",
      value: stats?.engagement
        ? formatNumberWithSuffix(stats?.engagement) + "%"
        : "N/A",
    },
    {
      label: "Likes",
      value: stats?.total_likes
        ? formatNumberWithSuffix(stats?.total_likes)
        : 0,
    },
    {
      label: "Comments",
      value: stats?.total_comments
        ? formatNumberWithSuffix(stats?.total_comments)
        : 0,
    },
    {
      label: "Views",
      value: stats?.total_views
        ? formatNumberWithSuffix(stats?.total_views)
        : 0,
    },
  ];
};

const SocialStats = ({ icon, link, stats, onClick }) => {
  return (
    <Box
      sx={{
        background: "#fff",
        padding: "1.5rem",
        borderRadius: "8px",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <Grid container>
        <Grid size={3}>
          <Box display={"flex"} alignItems={"center"} gap={1}>
            <img
              src={icon}
              alt="Instagram"
              style={{
                width: "30px",
                height: "30px",
              }}
            />
            <Typography>{link}</Typography>
          </Box>
        </Grid>
        <Grid size={9}>
          <Box
            display={"flex"}
            alignItems={"center"}
            gap={3}
            justifyContent={"end"}
          >
            {stats.map((stat, index) => (
              <Box
                display={"flex"}
                alignItems={"center"}
                flexDirection={"column"}
                key={index}
              >
                <Typography fontSize={"18px"} fontWeight={600} color="#676767">
                  {stat.value}
                </Typography>
                <Typography color="#676767" fontSize={"14px"}>
                  {stat.label}
                </Typography>
              </Box>
            ))}
          </Box>
          <Box display={"flex"} alignItems={"center"} gap={1}></Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export const Platforms = ({ details, onPlatformClick }) => {
  const socialLinks = details?.socialLinks || {};

  return (
    <Box display={"flex"} flexDirection={"column"} gap={"1rem"}>
      {socialLinks?.instagram ? (
        <SocialStats
          icon={Instagram}
          link={socialLinks?.instagram}
          stats={getInstagramStats({
            ...(details?.instagram_stats || {}),
            engagement: details?.engagement || 0,
          })}
          onClick={() => onPlatformClick("instagram")}
        />
      ) : (
        <></>
      )}
      {socialLinks?.youtube ? (
        <SocialStats
          icon={Youtube}
          link={socialLinks?.youtube}
          stats={getYouTubeStats({
            ...(details?.youtube_stats || {}),
            engagement: details?.engagement || 0,
          })}
          onClick={() => onPlatformClick("youtube")}
        />
      ) : (
        <></>
      )}

      {/* <SocialStats
        icon={Youtube}
        link={socialLinks?.instagram}
        stats={getInstagramStats(details?.instagram_stats)}
      />
      <SocialStats
        icon={Facebook}
        link={socialLinks?.instagram}
        stats={getInstagramStats(details?.instagram_stats)}
      />
      <SocialStats
        icon={SnapChat}
        link={socialLinks?.instagram}
        stats={getInstagramStats(details?.instagram_stats)}
      />
      <SocialStats
        icon={Reddit}
        link={socialLinks?.instagram}
        stats={getInstagramStats(details?.instagram_stats)}
      /> */}
    </Box>
  );
};
